import { Button, Space } from "antd";
import type { CSSProperties } from "react";

export interface ToggleButtonOption {
  label: string;
  value: string;
  disabled?: boolean;
}

interface ToggleButtonGroupProps {
  options: ToggleButtonOption[];
  value: string[];
  onChange: (next: string[]) => void;
  style?: CSSProperties;
  activeType?: "primary" | "default";
}

const ToggleButtonGroup = ({
  options,
  value,
  onChange,
  style,
  activeType = "primary",
}: ToggleButtonGroupProps) => {
  const handleToggle = (optionValue: string) => {
    const set = new Set(value);
    if (set.has(optionValue)) {
      set.delete(optionValue);
    } else {
      set.add(optionValue);
    }
    onChange(Array.from(set));
  };

  return (
    <Space.Compact style={{ minWidth: 200, ...style }}>
      {options.map((option, _index) => {
        const active = value.includes(option.value);
        return (
          <Button
            key={option.value}
            style={{ minWidth: 120 }}
            type={active ? activeType : "default"}
            onClick={() => handleToggle(option.value)}
            disabled={option.disabled}
          >
            {option.label}
          </Button>
        );
      })}
    </Space.Compact>
  );
};

export default ToggleButtonGroup;
